/* Careatic custom slide cart — AJAX cart + Section Rendering API.
   Checkout is the embedded Fastrr (Shiprocket) headless button, so express
   checkout opens exactly as before. Event-delegated so it survives re-renders. */
(function () {
  'use strict';
  var SECTION = 'ca-cart-drawer';
  function root() { return document.querySelector('[data-ca-cart-drawer]'); }
  if (!root()) return;

  function openCart() {
    var d = root(); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ca-cd-lock');
    loadRecs();
  }
  function closeCart() {
    var d = root(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ca-cd-lock');
  }
  function setCount(n) {
    document.querySelectorAll('[data-ca-cart-count]').forEach(function (el) { el.setAttribute('data-count', n); });
  }

  function refresh() {
    return fetch('/?sections=' + SECTION, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j[SECTION]; if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-ca-cart-drawer]');
        var cur = root();
        if (fresh && cur) {
          var wasOpen = cur.classList.contains('is-open');
          cur.innerHTML = fresh.innerHTML;
          if (wasOpen) { cur.classList.add('is-open'); cur.setAttribute('aria-hidden', 'false'); }
        }
      });
  }
  function syncCount() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); });
  }
  /* Cross-sell fallback: Shopify product recommendations when no upsell collection set */
  function loadRecs() {
    var box = document.querySelector('[data-ca-cd-recs]');
    if (!box) return;
    var rowEl = box.querySelector('[data-ca-cd-recsrow]');
    if (!rowEl || rowEl.getAttribute('data-loaded')) return;
    rowEl.setAttribute('data-loaded', '1');
    var pid = box.getAttribute('data-pid');
    if (!pid) { box.remove(); return; }
    fetch('/recommendations/products?section_id=ca-cart-recs&product_id=' + pid + '&limit=8&intent=related')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var cards = tmp.querySelector('[data-ca-cd-recscards]');
        if (cards && cards.children.length) { rowEl.innerHTML = cards.innerHTML; }
        else { box.remove(); }
      })
      .catch(function () { box.remove(); });
  }

  /* Offer codes: tap to copy, then the shopper pastes it in the Shiprocket coupon box.
     The copied code persists in sessionStorage so the "Copied" state survives re-renders. */
  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly', '');
    ta.style.position = 'fixed'; ta.style.top = '0'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }
  function markCopied() {
    var code = null;
    try { code = sessionStorage.getItem('caCopiedCode'); } catch (e) {}
    if (!code) return;
    var found = false;
    document.querySelectorAll('[data-ca-cd-copy]').forEach(function (b) {
      var on = b.getAttribute('data-ca-cd-copy') === code;
      if (on) { found = true; b.setAttribute('data-copied', ''); } else { b.removeAttribute('data-copied'); }
      var lbl = b.querySelector('[data-ca-cd-copylabel]');
      if (lbl) lbl.textContent = on ? 'Copied' : 'Copy';
    });
    var note = document.querySelector('[data-ca-cd-note]');
    if (note && found) {
      var b = document.createElement('b'); b.textContent = code;
      note.textContent = 'Paste ';
      note.appendChild(b);
      note.appendChild(document.createTextNode(' in the coupon box at checkout'));
    }
  }
  function copyCode(code) {
    function done() {
      try { sessionStorage.setItem('caCopiedCode', code); } catch (e) {}
      markCopied();
    }
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(done, function () { legacyCopy(code); done(); });
    } else { legacyCopy(code); done(); }
  }

  function after() { return Promise.all([refresh(), syncCount()]).then(function () { loadRecs(); markCopied(); }); }

  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }

  /* Add-to-cart forms anywhere on the site → AJAX + open drawer */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]:focus') || form.querySelector('[data-ca-add]') || form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return after(); })
      .then(openCart)
      .catch(function () { form.submit(); })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  }, true);

  /* Delegated clicks */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-ca-cart-count]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-ca-cart-close]')) { e.preventDefault(); closeCart(); return; }

    var cp = t.closest('[data-ca-cd-copy]');
    if (cp) { e.preventDefault(); copyCode(cp.getAttribute('data-ca-cd-copy')); return; }

    var line = t.closest('[data-ca-cd-line]');
    if (line) {
      var key = line.getAttribute('data-ca-cd-line');
      var qEl = line.querySelector('[data-ca-cd-qty]');
      var q = qEl ? (parseInt(qEl.textContent, 10) || 1) : 1;
      if (t.closest('[data-ca-cd-inc]')) { postJSON('/cart/change.js', { id: key, quantity: q + 1 }).then(after); return; }
      if (t.closest('[data-ca-cd-dec]')) { postJSON('/cart/change.js', { id: key, quantity: Math.max(0, q - 1) }).then(after); return; }
      if (t.closest('[data-ca-cd-remove]')) { postJSON('/cart/change.js', { id: key, quantity: 0 }).then(after); return; }
    }

    var add = t.closest('[data-ca-cd-add]');
    if (add) {
      var url = add.getAttribute('data-ca-cd-addurl');
      if (url) { window.location.href = url; return; }
      add.disabled = true;
      postJSON('/cart/add.js', { id: add.getAttribute('data-ca-cd-add'), quantity: 1 })
        .then(after).then(openCart).catch(function () { add.disabled = false; });
      return;
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  try { markCopied(); } catch (e) {}

  /* Cart reservation timer (urgency). End time persists in sessionStorage so the
     countdown survives drawer re-renders and page navigation within the session. */
  function tickTimer() {
    var el = document.querySelector('[data-ca-cd-timer]');
    var clock = el && el.querySelector('[data-ca-cd-clock]');
    if (!el || !clock) return;
    var mins = parseInt(el.getAttribute('data-minutes'), 10) || 10;
    var now = Date.now();
    var end = parseInt(sessionStorage.getItem('caCartTimerEnd') || '0', 10);
    if (!end || end <= now) { end = now + mins * 60000; sessionStorage.setItem('caCartTimerEnd', String(end)); }
    var rem = Math.max(0, end - now);
    var m = Math.floor(rem / 60000), s = Math.floor((rem % 60000) / 1000);
    clock.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }
  try { tickTimer(); setInterval(tickTimer, 1000); } catch (e) {}
})();
